const doc = [["event-2026-09_event-guide", "event-2026-09_ersti-special", "event-2026-09_presale-started", "2026-05_introduction"]];
module.exports = doc.length <= 1 ? doc[0] : doc;